module.exports = __webpack_public_path__ + "static/media/table_column_reorder_sample_1.dfca381a.png";